__turbopack_context__.v({
  "reviewsEmptyItem": "PageView-module__Mi4gEW__reviewsEmptyItem",
  "reviewsSection": "PageView-module__Mi4gEW__reviewsSection",
});
